<template>
  <nav class="navbar nav-bimplus" role="navigation" aria-label="main navigation">
    <div class="navbar-menu">
      <div class="navbar-start">
        <span v-if="isolateView" class="is-flex is-align-items-center">
          <i class="icon-disclosearrowleft pointer" @click="$emit('back')"></i>
        </span>
        <span v-else-if="!setModelVisible">
          <i class="icon-productionorderOL has-text-black-bis"></i>
        </span>
        <button v-if="title.id === 'projectSettings'" class="button is-outlined-viewer p-0 mt-2" @click="closeTab">
          <i class="icon-close has-text-black-bis"></i>
        </button>
        <div class="is-divider-vertical"></div>
        <div v-if="!isolateView">
          <h3 class="has-text-weight-semibold is-size-6 has-text-dark">{{ title.heading }}</h3>
          <h4 class="has-text-weight-semibold is-size-6 has-text-black-bis" v-html="title.value"></h4>
        </div>
        <div v-else>
          <h4 v-html="title.heading"></h4>
          <h4 v-html="title.value"></h4>
        </div>
      </div>
      <div v-if="title.id === 'addObjectsBySelection'" class="buttons mb-0">
        <button class="button is-outlined mb-0" @click="headerClick('back')">Back</button>
        <button class="button has-background-black-bis has-text-white mb-0" :disabled="!enableAddObjects" @click="headerClick('add')">Add Objects</button>
      </div>
      <div class="navbar-end">
        <div class="navbar-item">
          <div class="is-divider-vertical" v-if="title.id === 'projectSettings'"></div>
          <div v-if="title.id === 'projectSettings'">
            <button class="is-outlined-viewer button p-0" @click="toggleMfStage">
              <i class="icon-m-logo"></i>
            </button>
            <div  class="stage-viewer"  v-if="showMfStage">
              <div class="m-viewer is-flex is-align-items-center is-justify-content-space-between">
                 <div class="has-background-black-bis p-2">
                 <i class="icon-m-logo has-text-white"></i>
              </div>
              <h6 class="is-size-6 has-text-black-bis has-text-weight-semibold">MANUFACTON 
                STAGE</h6>

               <div class="is-divider-vertical mx-0"></div>
               <i class="icon-windowhandle has-text-black-bis mr-2"></i>
              </div>
              <div class="is-divider mt-0 mb-2"></div>
                <CompanyColors :legend="true" :edit="false">
              </CompanyColors>
            </div>
             
          </div>
          <!-- <div class="is-divider-vertical" v-if="title.id === 'projectSettings'"></div>
          <div v-if="title.id === 'projectSettings'">
            <button class="is-outlined-viewer button p-0" @click="toggleFilterModal">
            <i class="icon-modelfilter"></i>
            </button>
            <BimPlusFilter 
              :visible="showFilters"
              :projectId="projectId"
              :models="projectModels"
              :bimplusProjectId="bimplusProjectId"
              @close-modal="showFilters = false">
            </BimPlusFilter>
          </div>
          <div class="is-divider-vertical" v-if="title.id === 'projectSettings'"></div>
          <div v-if="title.id === 'projectSettings'">
            <button class="is-outlined-viewer button p-0" @click="toggleModelSettingsModal">
              <i class="icon-modelsettings" ></i>
            </button>
            <ModelSettings
              :visible="showModelSettings"
              @close-modal="showModelSettings = false">
            </ModelSettings>
          </div> -->
          <div class="is-divider-vertical"></div>
          <button class="is-outlined-viewer button p-0" @click="openBimPlusViewer">
            <i class="icon-bimplus"></i>
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import {reactive, onBeforeMount, toRefs, onMounted} from 'vue';
import { useRouter } from 'vue-router';
import BimPlusFilter from '../../components/bimplus/BimPlusFilter.vue';
import CompanyColors from '@/views/lmv/CompanyColors.vue';
import ModelSettings from '../../components/bimplus/ModelSettings.vue';
import bimplusViewer from '../../views/bimplus/bimplusViewer';
import urls from '@/urls';

export default {
  name: 'ViewerMainHeader',
  props: {
    projectId: {
      type: String,
      default: '',
    },
    title: {
      type: Object,
      default: {
        heading: '',
        value: ''
      }
    },
    bimplusTeamSlug: {
      type:String,
      default: '',
    },
    bimplusProjectId: {
      type:String,
      default: '',
    },
    isolateView: {
      type: Boolean,
      default: false,
    },
    setModelVisible: {
      type: Boolean,
      default: false,
    },
    enableAddObjects: {
      type: Boolean,
      default: false
    }
  },
  components: { BimPlusFilter, CompanyColors, ModelSettings },

  setup(props, {emit}) {
    const router = useRouter();
    const data = reactive ({
      showFilters: false,
      showMfStage: false,
      showModelSettings: false
    });

    const toggleFilterModal = () => {
      data.showFilters = !data.showFilters;
    };

    const toggleMfStage = () => {
      data.showMfStage = !data.showMfStage;
    };

    const toggleModelSettingsModal = () => {
      data.showModelSettings = !data.showModelSettings;
    };

    const closeTab = () => {
      router.go(-1);
    };

    const headerClick = async (event) => {
      if (event === 'back') {
        emit('addItemView', {event});
      } else if (event === 'add') {
        const selectedElements = await bimplusViewer.selectObjectInViewer();
        emit('addItemView', {selectedElements, event});
      }
    };
    const openBimPlusViewer = () => {
      window.open(`https://portal${urls.bimplusEnvironment !== 'prod' ? '-stage' : ''}.bimplus.net/viewer/#/viewer?project_id=${props.bimplusProjectId}&team_id=${props.bimplusTeamSlug}`, '_blank');
    };

    return{
      ...toRefs(data),
      toggleFilterModal,
      toggleMfStage,
      toggleModelSettingsModal,
      openBimPlusViewer,
      headerClick,
      closeTab,
    }
  },
  

};

</script>